import { Box, Typography } from "@mui/material";

import AuthForm from "@common-components/AuthForm/AuthForm";

const AuthPage = () => {
  return (
    <Box
      sx={{
        padding: "20px",
        minHeight: "92vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "45px",
          borderRadius: "20px",
          boxShadow:
            "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
          minWidth: "450px",
          minHeight: "550px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "20px",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              color: "primary.main",
              textAlign: "center",
              fontSize: "1.8rem",
            }}
          >
            Welcome to the <br />
            Lot Specific Platform
          </Typography>
          <Typography
            sx={{
              color: "title.main",
              textAlign: "center",
              fontSize: "0.8rem",
            }}
          >
            Sign in to access your projects and models
          </Typography>
        </div>
        <AuthForm />
      </Box>
    </Box>
  );
};

export default AuthPage;
